import { z } from 'zod';
import type { ZoneDoc } from '@ledium/types';
import { nameSchema, descriptionSchema } from './primitives.js';

type ZoneInput = Omit<ZoneDoc, '_id'>;

export const createZoneSchema = z.object({
    name: nameSchema,
    description: descriptionSchema,
    parent: z.string(),
    order: z.number().int().optional()
}) satisfies z.ZodType<ZoneInput>;

// PATCH sends only changed fields — $set updates only what is present
export const updateZoneSchema = createZoneSchema.partial();
